import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import store from '../store'
import Cookies from "js-cookie";

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
    mode: 'history',
    routes, // short for routes: routes
    linkActiveClass: 'active',
    scrollBehavior: (to, from, savedPosition) => {
        if (savedPosition) {
            return savedPosition;
        }
        if (to.hash) {
            return {selector: to.hash};
        }
        return {x: 0, y: 0};
    }
});

router.beforeEach((to, from, next) => {
    const user = store.getters.getUser;
    const token = Cookies.get('access_token');
    const deviceToken = Cookies.get('device_token');

    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const guest = to.matched.some(record => record.meta.guest);
    const onlyAdmin = to.matched.some(record => record.meta.onlyAdmin);
    const onlyAssistAdmin = to.matched.some(record => record.meta.onlyAssistAdmin);

    // Auth routes
    if (requiresAuth) {
        if (user && token && deviceToken) {
            if (onlyAssistAdmin) {
                console.log(user);
                if (!!user.assist_admin) {
                    next();
                } else {
                    next({path: '/'});
                }
            } else if (onlyAdmin) {
                if (user.role === 'admin') {
                    next();
                } else {
                    next({path: '/'});
                }
            } else {
                next();
            }
        } else {
            next({
                path: '/login',
                query: {
                    redirect: to.fullPath,
                },
            });
        }
    } else if(guest) { // Unauthenticated routes
        if (user && token && deviceToken) {
            next({path: '/'});
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;
